import { render } from "./ApplicationDocumentsModal.vue?vue&type=template&id=5382cc18&scoped=true"
import script from "./ApplicationDocumentsModal.vue?vue&type=script&lang=js"
export * from "./ApplicationDocumentsModal.vue?vue&type=script&lang=js"

import "./ApplicationDocumentsModal.vue?vue&type=style&index=0&id=5382cc18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5382cc18"]])

export default __exports__